module.exports = __webpack_public_path__ + "img/Path 844.5bb9b555.svg";